import { Injectable } from '@angular/core';  
import { UrlTree } from '@angular/router';  
import { Observable } from 'rxjs';  
import { AuthHelperService } from './services/auth-helper.service';
  
@Injectable({  
  providedIn: 'root'  
})
 
export class AuthGuard {  
  
  constructor(private readonly authHelper: AuthHelperService) { }  
  
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {     
    if (this.authHelper.isAuthenticated) {     
      return true;    
    }    
    return false;    
  }  
}  